import {
  Button,
  Card,
  Col,
  Collapse,
  Descriptions,
  Divider,
  Icons,
  PageHeader,
  Row,
  Table,
  Tag,
  useModalForm,
  Space,
  DateField,
} from '@pankod/refine-antd'
import { useGetIdentity, useList, useMany, useOne, useShow, useTable } from '@pankod/refine-core'
import { getSubSectionByIds } from 'gql/query'
import { ISubject, IPaperRequest, ITestTrack, IPaperTemplate, ISection, IPaperTemplateSubSection, IGrade, IPaper } from 'interfaces'
import paperTemplateMetaData from 'metadata/paperTemplate'
import { useEffect, useState } from 'react'
import { getMultipleUsers } from 'users'
import paperTemplateSubSectionMetaData from 'metadata/paperTemplateSubSections'
import { EditTestEventWorkRequest } from './edit'
import { CaretRightOutlined } from '@ant-design/icons'
import paperMetadata from 'metadata/paper'
import paperRequestMetadata from 'metadata/paperRequests'

import { useUserContext } from 'context/user'

interface PaperData {
  template_name: string
  id: string
  secion_name: string
  paper_setter: string
  approvers_details: string
  subsection_details: object[]
  test_track: string
}

interface PaperRequestProps {
  record?: IPaperRequest
}
const { Panel } = Collapse

export const PaperRequestShowHeader = ({ record }: PaperRequestProps) => {
  const { data: user } = useGetIdentity()
  const [subjectListIds, setSubjectListIds] = useState<string[]>([])
  const [gradeListIds, setGradeListIds] = useState<string[]>([])
  const [sectionListIds, setSectionListIds] = useState<string[]>([])
  const [paperTemplateSubSectionData, setPaperTemplateSubSectionData] = useState<IPaperTemplateSubSection[]>([])

  const { userRole } = useUserContext()

  // const { data: testTrack } = useOne<ITestTrack>({
  //   resource: 'test_tracks',
  //   id: record?.test_track_id || '',
  //   queryOptions: {
  //     enabled: !!record?.test_track_id,
  //   },
  //   metaData: {
  //     fields: ['id', 'name', 'subject_ids', 'grade_ids'],
  //   },
  // })

  const { data: testTrackSubjects } = useMany<ISubject>({
    resource: 'subjects',
    ids: subjectListIds,
    queryOptions: {
      enabled: !!subjectListIds,
    },
    metaData: {
      fields: ['id', 'name'],
    },
  })

  const { data: testTrackGrades } = useMany<IGrade>({
    resource: 'grades',
    ids: gradeListIds,
    queryOptions: {
      enabled: !!gradeListIds,
    },
    metaData: {
      fields: ['id', 'name'],
    },
  })

  // const { data: paperTemplate } = useOne<IPaperTemplate>({
  //   resource: 'paper_templates',
  //   id: record?.paper_template_id || '',
  //   queryOptions: {
  //     enabled: !!record?.paper_template_id,
  //   },
  //   metaData: paperTemplateMetaData,
  // })

  const paperTemplateSections = useMany<ISection>({
    resource: 'sections',
    ids: sectionListIds,
    queryOptions: {
      enabled: !!sectionListIds,
    },
    metaData: {
      fields: ['id', 'name'],
    },
  })

  // const paperTemplateSubSections = useList<IPaperTemplateSubSection>({
  //   resource: 'paper_template_sub_sections',
  //   config: {
  //     filters: [
  //       {
  //         field: 'paper_template_id',
  //         operator: 'eq',
  //         value: record?.paper_template_id,
  //       },
  //     ],
  //   },
  //   metaData: paperTemplateSubSectionMetaData,
  // })

  const slotData = record?.slot_data && JSON.parse(record?.slot_data)

  const { data: parentPaperResponse } = useOne<IPaper>({
    id: record?.parent_paper_id ?? '',
    resource: 'papers',
    queryOptions: { enabled: !!record?.parent_paper_id, staleTime: Infinity },
    metaData: paperMetadata,
  })
  const parentPaperData = parentPaperResponse?.data

  const {
    modalProps: editModalProps,
    formProps: editFormProps,
    show: editShow,
  } = useModalForm<IPaperRequest>({ resource: 'paper_requests', action: 'edit', metaData: paperRequestMetadata })

  useEffect(() => {
    if (!!record?.paper_template) {
      setSectionListIds(record?.paper_template?.sections)
    }
  }, [record?.paper_template])

  useEffect(() => {
    if (!!record?.test_track) {
      setGradeListIds(record?.test_track?.grade_ids)
      setSubjectListIds(record?.test_track?.subject_ids)
    }
  }, [record?.test_track])

  const disableEditButton = (record: IPaperRequest | undefined): boolean => {
    if (userRole === 'productmanager' || userRole === 'admin') {
      if (record?.status === 'Completed' || record?.status === 'Closed' || record?.status === 'In Progress') {
        if (record?.papers?.length && record?.papers?.length > 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return true
    }
  }

  // useEffect(() => {
  //   if (paperTemplateSubSections) setPaperTemplateSubSectionData(paperTemplateSubSections?.data?.data || [])
  // }, [paperTemplateSubSections])

  return (
    <PageHeader
      className="site-page-header-responsive"
      ghost={false}
      title={record?.name}
      extra={[
        <Button key="close" onClick={() => window.history.back()} icon={<Icons.LeftOutlined />}>
          Back
        </Button>,

        <Button
          // style={{
          //   display: editPermission !== undefined && editPermission?.granted ? 'block' : 'none',
          // }}
          disabled={record?.status === 'Completed' || record?.status === 'Closed' || record?.created_by !== user?.id || disableEditButton(record)}
          key="edit"
          icon={<Icons.EditOutlined />}
          type="primary"
          onClick={() => {
            editShow(record?.id)
          }}
        >
          Edit
        </Button>,
      ]}
    >
      <Descriptions size="small" column={3}>
        <Descriptions.Item label="">{<Tag color="blue">{record?.status}</Tag>}</Descriptions.Item>
      </Descriptions>
      <Descriptions size="small" column={3}>
        <Descriptions.Item label="Test Event">{record?.test_event?.name}</Descriptions.Item>
        <Descriptions.Item label="Product">{record?.test_event?.product?.name}</Descriptions.Item>
        <Descriptions.Item label="Paper Template">{record?.paper_template?.name}</Descriptions.Item>
        <Descriptions.Item label="Mode of Exam">{record?.test_event?.mode_of_exam}</Descriptions.Item>
        <Descriptions.Item label="Location">{record?.test_event?.location}</Descriptions.Item>
        <Descriptions.Item label="Restrictions">{record?.test_event?.restrictions}</Descriptions.Item>
        <Descriptions.Item label="Date and Time">
          <Space>
            <DateField value={slotData?.date} format="LL" />
            <Tag>
              <Space>
                <DateField value={slotData?.start_time} format="LT" />
                <DateField value={slotData?.end_time} format="LT" />
              </Space>
            </Tag>
          </Space>
        </Descriptions.Item>
        {/* {record?.project_config?.name && <Descriptions.Item label="Project">{record?.project_config?.name}</Descriptions.Item>} */}
        {record?.parent_paper_id ? (
          <Descriptions.Item label="Parent Paper">
            #{parentPaperData?.paper_id} {parentPaperData?.paper_smart_id}
          </Descriptions.Item>
        ) : null}
      </Descriptions>
      <Divider style={{ margin: ' 0', marginBottom: 15 }} />
      <b>Users</b>
      <Descriptions size="small" column={3}>
        <Descriptions.Item label="Paper Setter">{record?.userByPaperSetter?.displayName}</Descriptions.Item>
        <Descriptions.Item label="Paper Approver">{record?.userByPaperApprover?.displayName}</Descriptions.Item>
      </Descriptions>
      <Divider style={{ margin: ' 0', marginBottom: 15 }} />
      <b>Test Track Details</b>
      <Descriptions size="small" column={3}>
        <Descriptions.Item label="Test Track Name">{record?.test_track?.name}</Descriptions.Item>
        <Descriptions.Item label="Subjects">
          {testTrackSubjects?.data?.map(item => (
            <>{`${item?.name}, `}</>
          ))}
        </Descriptions.Item>
        <Descriptions.Item label="Grades">
          {testTrackGrades?.data?.map(item => (
            <Tag>{`${item?.name}`}</Tag>
          ))}
        </Descriptions.Item>
      </Descriptions>

      <Divider style={{ margin: '0', marginBottom: 15 }} />
      <b>Paper Template Details</b>
      <div style={{ marginTop: 5 }}>
        <Collapse style={{ marginTop: '12px' }}>
          {paperTemplateSections?.data?.data?.map((section, idx) => {
            const subSections = record?.paper_template?.paper_template?.filter((item: IPaperTemplateSubSection) => item.section_id === section?.id)
            return (
              <Panel header={section?.name} key={idx}>
                {subSections?.map((subSection: IPaperTemplateSubSection) => {
                  return (
                    <Collapse key={`subSection-${idx}`} expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}>
                      <Panel header={`Sub-Section : ${subSection.name}`} key={`Panel-${subSection.id}`} style={{ marginBottom: '10px' }}>
                        <Descriptions size="small" column={3}>
                          <Descriptions.Item label="Sub Section Name">{subSection.name}</Descriptions.Item>
                          <Descriptions.Item label="Subject">{subSection?.subject?.name}</Descriptions.Item>
                          <Descriptions.Item label="Report Theme">{subSection?.report_theme?.name ?? 'Not-provided'}</Descriptions.Item>
                          <Descriptions.Item label="Theme">{subSection?.theme?.name ?? 'Not-provided'}</Descriptions.Item>
                          <Descriptions.Item label="Sub Theme">{subSection?.sub_theme?.name ?? 'Not-provided'}</Descriptions.Item>
                          <Descriptions.Item label="Topic">{subSection?.topic?.name ?? 'Not-provided'}</Descriptions.Item>
                          <Descriptions.Item label="Number of Questions">{`${subSection?.no_of_questions}`}</Descriptions.Item>
                          <Descriptions.Item label="Mark per Questions">{subSection?.mark_per_question}</Descriptions.Item>
                        </Descriptions>
                      </Panel>
                    </Collapse>
                  )
                })}
              </Panel>
            )
          })}
        </Collapse>
      </div>
      <Divider style={{ margin: '10px 0 0 ' }} />
      <EditTestEventWorkRequest formProps={editFormProps} modalProps={editModalProps} record={record} request={{}} />
    </PageHeader>
  )
}
